import styled from 'styled-components';

export const ToggleButton = styled.button<{ $isActive: boolean; $isVisible: boolean }>`
  position: fixed;
  bottom: 100px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: 1.5px solid ${({ $isActive }) => ($isActive ? '#ff1493' : '#00ff88')};
  border-radius: 12px;
  color: ${({ $isActive }) => ($isActive ? '#ff1493' : '#00ff88')};
  height: 70px;
  padding: 0 60px;
  font-family: 'Share Tech Mono', monospace;
  font-size: 29px;
  font-weight: 500;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 100;
  display: ${({ $isVisible }) => ($isVisible ? 'block' : 'none')};
  box-shadow: ${({ $isActive }) =>
    $isActive
      ? '0 0 20px rgba(255, 20, 147, 0.4), inset 0 0 20px rgba(255, 20, 147, 0.1)'
      : '0 0 20px rgba(0, 255, 136, 0.4), inset 0 0 20px rgba(0, 255, 136, 0.1)'};

  &:hover {
    box-shadow: ${({ $isActive }) =>
      $isActive
        ? '0 0 35px rgba(255, 20, 147, 0.6), inset 0 0 25px rgba(255, 20, 147, 0.15)'
        : '0 0 35px rgba(0, 255, 136, 0.6), inset 0 0 25px rgba(0, 255, 136, 0.15)'};
    text-shadow: ${({ $isActive }) =>
      $isActive ? '0 0 15px rgba(255, 20, 147, 0.8)' : '0 0 15px rgba(0, 255, 136, 0.8)'};
  }

  @media (max-width: 768px) {
    font-size: 22px;
    padding: 0 40px;
    height: 56px;
    bottom: 85px;
  }

  @media (max-height: 500px) and (orientation: landscape) {
    height: 48px;
    font-size: 19px;
    padding: 0 32px;
    bottom: 75px;
  }
`;
